










































































































































































































































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import ObjektiCard1 from "@/views/Objekti/ObjektiCard1.vue";
import { ComponentBaseMixin } from "@/mixins/component-base.mixin";
import { mixins } from "vue-class-component";
import ObjektiCard2TabOsnovno from "@/views/Objekti/ObjektiCard2Tab-1-Osnovno.vue";
import ObjektiCard2TabDodatno from "@/views/Objekti/ObjektiCard2Tab-2-Dodatno.vue";
import ObjektiCard2TabPrometi from "@/views/Objekti/ObjektiCard2Tab-3-Prometi.vue";
import ObjektiCard2TabPosete from "@/views/Objekti/ObjektiCard2Tab-4-Posete.vue";
import ObjektiCard2TabStalci from "@/views/Objekti/ObjektiCard2Tab-5-Stalci2.vue";
import ObjektiCard2Tab8Beleske from "@/views/Objekti/ObjektiCard2Tab-8-Beleske.vue";
import { formatDate } from "@/utils/formatters";
import { StoreModel } from "@/views/Objekti/StoreModel";
import "../../assets/js/jquery.Photostack.js";
import ObjektiCard2Tab9Kategorizacija from "@/views/Objekti/ObjektiCard2Tab-9-Kategorizacija.vue";
import ObjektiCard2Tab7Lokacija from "@/views/Objekti/ObjektiCard2Tab-7-Lokacija.vue";
import ObjektiCard2Tab10Pozicije from "@/views/Objekti/ObjektiCard2Tab-10-Pozicije.vue";
import ObjektiCard2Tab11Zalihe from "@/views/Objekti/ObjektiCard2Tab-11-Zalihe.vue";

@Component({
    name: "objekti",
    components: {
        "objekti-card-1": ObjektiCard1,
        "objekti-card-2-tab-osnovno": ObjektiCard2TabOsnovno,
        "objekti-card-2-tab-dodatno": ObjektiCard2TabDodatno,
        "objekti-card-2-tab-promet": ObjektiCard2TabPrometi,
        "objekti-card-2-tab-posete": ObjektiCard2TabPosete,
        "objekti-card-2-tab-stalci": ObjektiCard2TabStalci,
        "objekti-card-2-tab-lokacija": ObjektiCard2Tab7Lokacija,
        "objekti-card-2-tab-beleske": ObjektiCard2Tab8Beleske,
        "objekti-card-2-tab-kategorizacija": ObjektiCard2Tab9Kategorizacija,
        "objekti-card-2-tab-pozicije": ObjektiCard2Tab10Pozicije,
        "objekti-card-2-tab-zalihe": ObjektiCard2Tab11Zalihe,
    },
})
export default class Objekti extends mixins(ComponentBaseMixin) {
    storeCategorization1 = [];
    storeCategorization2 = [];
    storeCategorization3 = [];
    storeCategorization4 = [];
    storeCategorization5 = [];
    storeCategorization6 = [];
    storeCategorization8 = [];
    storeCategorization9 = [];

    chains = [];
    storeCategories = [];
    storeTypes = [];
    suppliers = [];
    users = [];
    racks = [];

    turnovers = [];
    visits = [];
    racksInStore = [];
    stock = [];
    images: any = [];
    notes = [];

    store = new StoreModel();

    isBusySave = false;
    isBusyLoadingTurnovers = false;
    isBusyLoadingVisits = false;
    isBusyLoadingRacks = false;
    isBusyLoadingStock = false;

    activated() {
        let row = { publicId: undefined, id: undefined };
        row.publicId = this.$route.params.storePublicID;
        row.id = this.$route.query.storeID;

        if (row.publicId !== undefined && row.id !== undefined) {
            if (Number(this.store.id) !== Number(row.id)) {
                this.onClickRow(row);
            }
        }
    }

    async created() {
        try {
            await this.axios.get("/api/GetDataForStores").then((result) => {
                this.storeCategorization1 = [
                    {id: 1, title: "Preko 2 miliona"},
                    {id: 2, title: "500 hiljada do 2 miliona"},
                    {id: 3, title: "200 hiljada do 500 hiljada"},
                    {id: 4, title: "50 hiljada do 200 hiljada"},
                    {id: 5, title: "20 hiljada do 50 hiljada"},
                    {id: 6, title: "10 hiljada do 20 hiljada"},
                    {id: 7, title: "do 10 hiljada"},
                ];
                this.storeCategorization2 = [
                    {id: 8, title: "Gradsko urbano"},
                    {id: 9, title: "Gradsko"},
                    {id: 10, title: "Prigradsko urbano"},
                    {id: 11, title: "Prigradsko"},
                    {id: 12, title: "Seosko urbano"},
                    {id: 13, title: "Seosko"},
                ];
                this.storeCategorization3 = [
                    {id: 14, title: 'Prolazi autobus ulicom'},
                    {id: 15, title: 'Ne prolazi autobus ulicom'},
                ];
                this.storeCategorization4 = [
                    {id: 16, title: 'Osnovne škole'},
                    {id: 17, title: 'Srednje, više, visoke škola'},
                    {id: 18, title: 'Državne institucije'},
                ];
                this.storeCategorization5 = [
                    {id: 19, title: 'Porodičnim kućama'},
                    {id: 20, title: 'Stambenim zgradama'},
                ];
                this.storeCategorization6 = [
                    {id: 21, title: 'Hipermarket (preko 700 m2 ili 10 kasa)'},
                    {id: 22, title: 'Supermarket veliki (250-750 m2 ili 5-10 kasa)'},
                    {id: 23, title: 'Supermarket mali (100-250 m2 ili 3 kase)'},
                    {id: 24, title: 'Prodavnica velika (50-100 m2 ili 2 kase)'},
                    {id: 25, title: 'Prodavnica mala (do 50m2 ili 1 kasa)'},
                ];
                this.storeCategorization8 = [
                    {id: 68, title: 'U blizini autobuske stanice'},
                    {id: 69, title: 'Nije u blizini autobuske stanice'},
                ];
                this.storeCategorization9 = [
                    {id: 70, title: '1'},
                    {id: 71, title: '2'},
                    {id: 72, title: '3'},
                    {id: 73, title: '5'},
                    {id: 74, title: '10'},
                    {id: 75, title: '20'},
                ];
                this.chains = result.data.chains;
                this.storeCategories = result.data.storeCategories;
                this.storeTypes = result.data.storeTypes;
                this.suppliers = result.data.suppliers;
                this.users = result.data.users;
                this.racks = result.data.racks;
            });

            this.storeCategories = this.storeCategories.map((x) => ({
                id: x.id,
                publicId: x.publicId,
                name: x.display,
            }));

            this.suppliers.unshift({ id: "", publicId: "", name: "..." });
            this.suppliers = this.suppliers.map((x) => ({
                id: x.id,
                publicId: x.publicId,
                name: x.name,
            }));

            this.storeTypes.unshift({ id: "", publicId: "", name: "..." });
            this.storeTypes = this.storeTypes.map((x) => ({
                id: x.id,
                publicId: x.publicId,
                name: x.name,
            }));

            this.chains.unshift({ id: "", publicId: "", name: "..." });
            this.chains = this.chains.map((x) => ({
                id: x.id,
                publicId: x.publicId,
                name: x.name,
            }));

            this.users.unshift({ id: "", firstName: "...", lastName: "" });
            this.users = this.users.map((x) => ({
                id: x.id,
                name: `${x.firstName} ${x.lastName}`,
            }));

            this.racks.unshift({ id: "", name: "..." });
            this.racks = this.racks.map((x) => ({
                id: x.id,
                name: `${x.name}`,
            }));
        } catch (err) {
            this.showError("neuspesnoUcitavanjePodataka");
        }
    }

    async onClickRow(row) {
        await this.axios
            .get(`api/GetStoreByPublicId/${row.publicId}`)
            .then((result) => {
                if (result.status === 200) {
                    this.store = result.data;
                }
                if (result.request.status === 404) {
                    this.showError("neuspesnoUcitavanjePodataka");
                }
            })
            .catch((err) => {
                this.showError("neuspesnoUcitavanjePodataka");
            });

        this.turnovers = [];
        this.visits = [];
        this.stock = [];
        this.racksInStore = [];

        this.isBusyLoadingTurnovers = true;
        this.axios
            .get(`api/GetTurnoverForStore/${row.id}`)
            .then((result) => {
                this.turnovers = result.data;
            })
            .catch((err) => {
                this.showError("neuspesnoUcitavanjaPrometa");
                this.isBusyLoadingTurnovers = false;
            })
            .finally(() => {
                this.isBusyLoadingTurnovers = false;
            });

        this.isBusyLoadingVisits = true;
        this.axios
            .get(`api/GetVisitsByPublicStoreId/${row.publicId}`)
            .then((result) => {
                this.visits = result.data;
            })
            .catch((err) => {
                this.showError("neuspesnoUcitavanjePoseta");
                this.isBusyLoadingVisits = false;
            })
            .finally(() => {
                this.isBusyLoadingVisits = false;
            });

        this.isBusyLoadingRacks = true;
        this.axios.get(`api/GetRacksInStore/${row.id}`)
            .then(({data}) => this.racksInStore = data)
            .catch(err => this.showError("neuspesnoUcitavanjeStalaka"))
            .finally(() => this.isBusyLoadingRacks = false);

        this.isBusyLoadingStock = true;
        this.axios
            .get(`api/GetProductStocksInStore/${row.id}`)
            .then(({data}) => this.stock = data)
            .catch((err) => this.showError("neuspesnoUcitavanjaPrometa"))
            .finally(() => this.isBusyLoadingStock = false);

        this.loadImages(row.id);

        this.firstStepInWizard();
    }

    async loadImages(id) {
      await this.axios
          .get(`api/GetImagesFromStore/${id}`)
          .then((result) => {
            this.images = result.data.map((x) => {
              return {
                images: x.images,
                date: formatDate(x.date),
              };
            });
            $("#pictures .photoStack").Photostack({
              animation: "elastic",
            });
            $(".fancybox").fancybox({
              animationEffect: "zoom",
              transitionEffect: "slide",
              thumbs: {
                autoStart: true,
              },
            });
          })
          .catch((err) => {
            this.showError("neuspesnoUcitavanjeSlika");
          });
      $("#pictures .photoStack").Photostack({
        animation: "elastic",
      });
      $(".fancybox").fancybox({
        animationEffect: "zoom",
        transitionEffect: "slide",
        thumbs: {
          autoStart: true,
        },
      });
    }

    async deleteStore() {
        try {
            if (this.store.id) {
                const yes = await this.confirmationNeeded(
                    "da li ste sigurni da zelite da obrisete objekat?"
                );
                if (yes) {
                    await this.axios.delete(`api/DeleteStore/${this.store.id}`);
                    this.newStore();
                    this.showInfo("objekatUspesnoObrisan");
                    await (<any>this.$refs['objekti-card-1']).naprednaPretraga();
                }
            } else {
                this.showError("morateIzabratiObjekatPreBrisanja");
            }
        } catch (e) {
            this.showError("neuspesnoBrisanjeObjekta");
        }
    }

    async saveStore() {
        //@ts-ignore
        const validTab1 = await (<any>(
            (<any>this.$refs.validTab1).$refs.observerOsnovno
        )).validate();
        //@ts-ignore
        const validTab2 = await (<any>(
            (<any>this.$refs.validTab2).$refs.observerDodatno
        )).validate();

        if (validTab1 && validTab2) {
            try {
                this.isBusySave = true;

                const store = {...this.store,
                  publicID: this.store.publicId || '00000000-0000-0000-0000-000000000000',
                  publicId: this.store.publicId || '00000000-0000-0000-0000-000000000000',
                  numberOfVisitsInLastYear: 0,
                  storeCategorization: {
                    categorization1Id: 0,
                    categorization2Id: 0,
                    categorization3Id: 0,
                    categorization4Id: 0,
                    categorization5Id: 0,
                    categorization6Id: 0,
                    categorization7Id: 0,
                    categorization8Id: 0,
                    categorization9Id: 0,
                  },
                  storeRate: 0,
                  storeRateSample: 0
                }

                await this.axios
                    .post("api/SaveStore", store)
                    .then((result) => {
                        if (result.status === 200 || result.status === 204) {
                            this.showInfo("podaciUspesnoSacuvani");
                            this.store.id = result.data;
                        }
                        if (result.status !== 200 && result.status !== 204) {
                            this.showError("neuspesnoCuvanjePodataka");
                        }
                    });
            } catch (e) {
                this.showError("neuspesnoCuvanjePodataka");
                this.isBusySave = false;
            } finally {
                this.isBusySave = false;
            }
        } else {
            this.showError("podaci nisu validni");
        }
    }

    newStore() {
        this.store = new StoreModel();
        this.turnovers = [];
        this.visits = [];
        this.stock = [];
        this.images = [];
        this.notes = [];
        this.firstStepInWizard();
    }

    firstStepInWizard() {
        //@ts-ignore
        if (<any>this.$refs.kategorizacija) {
            (<any>this.$refs.kategorizacija).goToFirstStepInWizard();
        }
    }

    removeLocation() {
        this.store.latitude = "";
        this.store.longitude = "";
    }

    updateStoreLatLng(Lat, Lng) {
        this.store.latitude = Lat;
        this.store.longitude = Lng;
    }

    async saveStorePositionRates(rates) {
        let totalRate = 0;
        for (let i = 0; i < rates.indexes.length; i++) {
            totalRate += rates.model[rates.indexes[i]].rate;
        }
        let rate = {
            storeID: this.store.id,
            storeTypeId: rates.typeId,
            selected: JSON.stringify(rates.indexes),
            sampleSize: rates.indexes.length,
            totalRate: totalRate,
        };
        try {
            await this.axios.put("api/stores/saveRates", rate);
            this.showInfo("podaciUspesnoSacuvani");
        } catch (err) {
            this.showError("neuspesnoCuvanjePodataka");
        }
    }
}
